// import React from "react";
import { requireAuth } from './../util/auth.js';

function DashboardPage(props) {
  return null;
}

export default requireAuth(DashboardPage);
